import {Component, OnInit} from '@angular/core';
import {UserPrivilegeEnum, UserService} from '@app/user.service';
import {User} from '@app/api/user-api.service';
import Utils from '@app/utils/utils';
import {
    ContextualMenuItem,
    NotificationService,
    SEPARATOR
} from '@agilent/ui-element';
import {Router} from '@angular/router';
import {AboutComponent} from '@app/pages/about/about.component';
import { environment } from '@env/environment';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css']
})

export class TopbarComponent implements OnInit {

    public authUser: User;
    public isLoading = true;
    public cidIcon;
    public openLabIcon: string;
    public activityLogIcon;
    public softwareLibraryIcon;
    public helpIcon;
    public productIcon;

    public menuItemsAdmin: ContextualMenuItem[] = [];
    public menuItemsHelp: ContextualMenuItem[] = [];
    public showAdditionalHubs = false;
    public canViewCids = false;
    public canViewOpenLabSystems = false;

    constructor(
        private userService: UserService,
        private router: Router,
        private notificationService: NotificationService) {
        //
    }

    public async ngOnInit() {
        this.authUser = await this.userService.getAuthUser();

        this.showAdditionalHubs = await this.userService.userHasPrivs(
            [UserPrivilegeEnum.VIEW_ADD_REMOVE_ADDITIONAL_HUBS], this.authUser.customer_id);

        this.canViewCids = await this.userService.userHasPrivs(
            [UserPrivilegeEnum.VIEW_CID], this.authUser.customer_id);

        this.canViewOpenLabSystems = await this.userService.userHasPrivs(
            [UserPrivilegeEnum.VIEW_SERVER], this.authUser.customer_id);

        await this.setupIcons();
        this.addAdminMenuItems();
        this.addHelpMenuItems();
        this.isLoading = false;
    }

    public logout() {
        this.userService.logOutUser();
    }

    private async setupIcons() {
        this.productIcon = await Utils.getSvgByUrl('/assets/icons/cid_hub.svg');
        this.cidIcon = await Utils.getSvgByUrl('/assets/icons/primary_nav_cids_24.svg');
        this.openLabIcon = await Utils.getSvgByUrl('/assets/icons/primary_nav_openlab_servers_24.svg');
        this.activityLogIcon = await Utils.getSvgByUrl('/assets/icons/system_activity_log_24.svg');
        this.softwareLibraryIcon = await Utils.getSvgByUrl('/assets/icons/primary_nav_software_library_24.svg');
        this.helpIcon = await Utils.getSvgByUrl('/assets/icons/primary_nav_right_help_circle_24.svg');
    }

    private async addAdminMenuItems() {
        this.menuItemsAdmin.push(...[
            {
                actionName: 'usersPageAction',
                label: 'Users',
                onClick: (actionName) => this.onMenuItemClicked(actionName)
            },
            SEPARATOR
        ]);
        if (await this.userService.userHasPrivs(
            [UserPrivilegeEnum.VIEW_DEVICE], this.authUser.customer_id)) {
            this.menuItemsAdmin.push(
                {
                    actionName: 'devicesPageAction',
                    label: 'Devices',
                    onClick: (actionName) => this.onMenuItemClicked(actionName)
                },
                SEPARATOR);
        }
        if (await this.userService.userHasPrivs(
            [UserPrivilegeEnum.VIEW_OTHER_ACCOUNTS], this.authUser.customer_id)) {
            this.menuItemsAdmin.push({
                actionName: 'customerPageAction',
                label: 'Customers',
                onClick: (actionName) => this.onMenuItemClicked(actionName)
            });
        } else {
            this.menuItemsAdmin.push(
                {
                    actionName: 'accountPageAction',
                    label: 'Account',
                    onClick: (actionName) => this.onMenuItemClicked(actionName)
                }
            );
        }

        if (this.showAdditionalHubs) {
            this.menuItemsAdmin.push(
                SEPARATOR,
                {
                    actionName: 'additionalHubsPageAction',
                    label: 'Additional Hubs',
                    onClick: (actionName) => this.onMenuItemClicked(actionName)
                }
            );

        }
    }

    private addHelpMenuItems() {
        this.menuItemsHelp.push(...[
            {
                actionName: 'cidHubHelpAction',
                label: 'Help',
                onClick: (actionName) => this.onMenuItemClicked(actionName)
            },
            SEPARATOR,
            {
                actionName: 'contactSupportAction',
                label: 'Contact Support',
                onClick: (actionName) => this.onMenuItemClicked(actionName)
            },
            SEPARATOR,
            {
                actionName: 'aboutCIDHubAction',
                label: 'About CID Hub',
                onClick: (actionName) => this.onMenuItemClicked(actionName)
            }
        ]);
    }

    private onMenuItemClicked(actionName) {
        switch (actionName) {
            case 'accountPageAction':
                return this.router.navigate(['/customers', this.authUser.customer_id]);

            case 'customerPageAction':
                return this.router.navigate(['/customers']);

            case 'usersPageAction':
                return this.router.navigate(['/users']);

            case 'cidHubHelpAction':
                window.open(`${environment.cognito_redirect_uri_sign_out}docs/`, "_blank");
                break;

            case 'contactSupportAction':
                window.open('/assets/agilent-support-contact-information.pdf', '_blank');
                break;

            case 'aboutCIDHubAction':
                this.notificationService.showModal(AboutComponent);
                break;

            case 'devicesPageAction':
                return this.router.navigate(['/devices']);

            case 'additionalHubsPageAction':
                return this.router.navigate(['/hubs']);

            default:
                this.notificationService.warning('Not yet implemented');
        }
    }
}
